import { render, staticRenderFns } from "./AuditTabs.vue?vue&type=template&id=13db9c30&scoped=true&"
import script from "./AuditTabs.vue?vue&type=script&lang=tsx&"
export * from "./AuditTabs.vue?vue&type=script&lang=tsx&"
import style0 from "./AuditTabs.vue?vue&type=style&index=0&id=13db9c30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13db9c30",
  null
  
)

export default component.exports